import axios from "../../interceptors/axiosInterceptor";
import {
  CREATE_RIDER_URL,
  DOWNLOAD_LOCUS_CSV_DUMP_URL,
  DOWNLOAD_PLAN_OUTPUT_CSV_DUMP_URL,
  GET_RIDER_JOB_TYPES_URL,
  GET_RIDER_LIST_URL,
  GET_USER_DETAIL_V2_URL,
  UPDATE_RIDER_URL,
  RESET_DEVICE_URL
} from "config/Url";
import { getAuthOptions } from "config/Headers";
import { normalizeCatchErrors } from "utils/errorUtils";
import { ICreateRiderRequestPayload,IRefreshDeviceRequestPayload } from "interfaces/riderManagement.interface";
import {
  IGetQueryParams,
  IUserDetailsResponseObject,
  IPlanCreation,
  IJobTypes,
} from "interfaces/Index";
import { normalizeFetchRiderManagementUserResponse } from "normalizer/RiderManagementNormalizer";
import { DATE_FORMAT, PAGE_LENGTH } from "config/constants";
import fileDownload from "js-file-download";
import { format } from "date-fns";

export const createRiderApiCall = (payload: ICreateRiderRequestPayload) =>
  new Promise<void>((resolve, reject) => {
    axios
      .post(CREATE_RIDER_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve(response.data);
        } else {
          reject({
            errors: "Something went wrong",
          });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchRiderListApiCall = (queryParam: IGetQueryParams = {}) =>
  new Promise((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(GET_RIDER_LIST_URL, requestConfig)
      .then((response) => {
        if (response) {
          const data = response && response.data;
          const pageNumber: number = queryParam.page
            ? Number(queryParam.page) + 1
            : 1;
          const isPaginatedRes =
            queryParam.page &&
            (queryParam.page as any) > 0 &&
            data.length >= PAGE_LENGTH
              ? true
              : false;
          resolve(
            normalizeFetchRiderManagementUserResponse(
              data,
              pageNumber,
              isPaginatedRes
            )
          );
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const getRiderUserDetailsApiCall = (id: string) =>
  new Promise<IUserDetailsResponseObject>((resolve, reject) => {
    let url = GET_USER_DETAIL_V2_URL.replace("{user_id}", id);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const updateRiderApiCall = (payload: any) => {
  return new Promise((resolve, reject) => {
    axios
      .put(UPDATE_RIDER_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve(response.data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};

export const getLocusCsvApiCall = (payload: IPlanCreation) => {
  return new Promise((resolve, reject) => {
    axios
      .post(DOWNLOAD_LOCUS_CSV_DUMP_URL, payload, getAuthOptions())
      .then((response) => resolve(response.data))
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};

export const getPlanOutputCsvApiCall = (planId: string) => {
  const configs = getAuthOptions();
  return new Promise((resolve, reject) => {
    axios
      .get(DOWNLOAD_PLAN_OUTPUT_CSV_DUMP_URL, {
        ...configs,
        params: { planId },
      })
      .then((response) => {
        fileDownload(
          response.data,
          `locus-plan-output${format(Date.now(), DATE_FORMAT.DATE_TIME)}.csv`
        );
        resolve(null);
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};

export const getRiderJobTypeApiCall = () => {
  return new Promise<IJobTypes>((resolve, reject) => {
    axios
      .get(GET_RIDER_JOB_TYPES_URL, getAuthOptions())
      .then((response) => resolve(response.data))
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};

export const updateRiderDeviceApiCall = (
  payload: IRefreshDeviceRequestPayload
) => {
  return new Promise<void>((resolve, reject) => {
    axios
      .put(RESET_DEVICE_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};
